import { render } from "./closeAccordion.vue?vue&type=template&id=0664a255"
import script from "./closeAccordion.vue?vue&type=script&lang=js"
export * from "./closeAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__